<template>
  <div class="utm-ellipsis-wrapper"  :class="{'expand':needExpand,'manual':type === 'ManualView','open':expand}" :id="domId">
    <!--多行隐藏-->
    <template v-if="type === 'MultipleLines'">
      <Tooltip class="utm-tooltip"
               :content="content"
               :theme="theme"
               :disabled="isDisabled"
               :transfer="transfer"
               :transfer-class-name="transferName"
               :max-width="tooltipMaxWidth"
               >
        <div class="utm-ellipsis-multiple-line" v-on:mouseenter="showLineCode($event)"
             :style="{'-webkit-line-clamp':lineClamp,'lineHeight': lineHeight}">
          <slot>
            <span class="utm-ellipsis-txt">{{content || content === 0 ? content : 'Not Applicable'}}</span>
          </slot>
        </div>
      </Tooltip>
    </template>
    <!--多行需要手动打开查看更多-->
    <template v-else-if="type === 'ManualView'">
      <div class="utm-ellipsis-multiple-manual"
           :style="{'-webkit-line-clamp': expand ? 'unset':lineClamp,'lineHeight': lineHeight}">
        <slot>
          <span class="utm-ellipsis-txt">{{content || content === 0 ? content : 'Not Applicable'}}</span>
        </slot>
      </div>
      <span class="utm-ellipsis-manualView-btn"> 
        <slot name="btn" :expand="expand">
          <i v-if="!stopEvent" class="arrow ivu-icon ivu-icon-ios-arrow-down" @click.stop="openMoreContent"></i>
          <i v-else class="arrow ivu-icon ivu-icon-ios-arrow-down" @click.stop="openMoreContent"></i>
        </slot>
      </span>
    </template>
    <!--单行隐藏-->
    <template v-else>
      <Tooltip v-if="showEllipsis" :content="content" class="utm-tooltip utm-ellipsis-tooltip" :placement="placement"
               :class="[{'nowrap':nowrap}]"
               :theme="theme"
               :disabled="isDisabled"
               :transfer="transfer"
               :transfer-class-name="transferName" :max-width="tooltipMaxWidth">
        <div class="utm-ellipsis" v-on:mouseenter="showCode($event)" :style="{'width': initWidth, 'lineHeight': lineHeight,'height':height}">
          <slot>
            <span class="utm-ellipsis-txt">{{content || content === 0 ? content : 'Not Applicable'}}</span>
          </slot>
        </div>
        <template #content>
            <slot name="customContent">
              <span>{{ content }}</span>
            </slot>
          </template>
      </Tooltip>
    </template>
  </div>
</template>

<script>
    export default {
      name: "utmEllipsis",
      props:{
        showEllipsis:{
          type:Boolean,
          default:true
        },
        placement:{
          type:String,
          default:'bottom-start'
        },
        content:{
          type: [String, Number],
          default:""
        },
        width:{
          type:String,
          default:'100%',
        },
        lineHeight:{
          type:String,
          default:'1.5',
        },
        transfer:{
          type:Boolean,
          default:false,
        },
        transferName:{
          type:String,
          default:"utm-ellipsis-tooltip-transfer"
        },
        /*是否多行隐藏*/
        type:{
          type:String,
          default:'Default'
        },
        /*最多显示行数，要开启多行显示*/
        lineClamp:{
          type:Number,
          default:2
        },
        theme:{
          type:String,
          default:'dark'
        },
        domId:{
          type:String,
          default:''
        },
        stopEvent:{
          type:Boolean,
          default:false
        },
        height:{
          type:String,
          default:null
        },
        tooltipMaxWidth:{
          type:String,
          default:'300px'
        },
        // 是否设置提示信息一行显示，需要配合tooltipMaxWidth使用
        nowrap:{
          type:Boolean,
          default:false
        },
      },
      computed:{
        initWidth: function(){
          return this.width === '100%' ? this.width:this.width.indexOf('px') > -1 ? this.width:this.width + 'px';
        },
      },
      data(){
        return{
          isDisabled:true,
          needExpand:false,
          expand:false
        }
      },
      mounted(){
        this.$nextTick(()=>{
          if(this.type === 'ManualView'){
            let dom = document.getElementById(this.domId);
            let target = $(dom).children('.utm-ellipsis-multiple-manual')[0];
            this.$nextTick(()=>{
              if(target.clientHeight < target.scrollHeight){
                this.needExpand = true;
              }
            })
          }
        });
      },
      methods:{
       
        showCode:function(e){
          let that = this;
          if(e.target.clientWidth < e.target.scrollWidth){
            that.isDisabled = false;
          }else{
            that.isDisabled = true;
          }
        },
        showLineCode:function(e){
          let that = this;
          if(e.target.scrollHeight > e.target.clientHeight){
            that.isDisabled = false;
          }else{
            that.isDisabled = true;
          }
        },
        openMoreContent:function(){
          this.expand = !this.expand;
        },
      
      },
    }
</script>
<style>
  .utm-ellipsis-wrapper .ivu-tooltip-rel{
    line-height: 1;
  }
</style>
<style scoped>
  .utm-ellipsis-wrapper{
    line-height: 1;
  }
  .utm-ellipsis{
    position: relative;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
  }
  .utm-ellipsis-tooltip{
    width: 100%;
    line-height: 1;
  }
  .utm-ellipsis-txt{
    padding-right: 2px;
  }
  .utm-ellipsis-multiple-line{
    display: -webkit-box;
    white-space: initial;
    overflow: hidden; 
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }
  /*手动打开的*/
  .utm-ellipsis-wrapper.manual{
    position: relative;
  }
  .utm-ellipsis-wrapper.expand{
    padding-right: 20px;
  }
  .utm-ellipsis-wrapper.open .utm-ellipsis-multiple-manual{
    white-space: normal;
    word-break: break-word;
    overflow: hidden;
    text-overflow: unset;
  }
  .utm-ellipsis-multiple-manual{
    display: -webkit-box;
    white-space: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }
  .utm-ellipsis-manualView-btn{
    display: none;
    position: absolute;
    right: -6px;
    top: 0;
    width: 24px;
    height: 24px;
    cursor: pointer;
    transform: rotate(0deg);
    transform-origin: 50% 50%;
    transition: transform .15s ease-in;
    text-align: center;
    line-height: 24px;
  }
  .utm-ellipsis-wrapper.open .utm-ellipsis-manualView-btn{
    transform: rotate(180deg);
  }
  .utm-ellipsis-wrapper.expand .utm-ellipsis-manualView-btn{
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/admin/components/commonComponents/utmEllipsis.vue